import { useEffect } from 'react';

/**
 * Habilita la instalación del PWA solo mientras este componente está montado
 * (se usa en /login). La página pública de puntos no ofrece "Instalar app".
 */
const PwaManifest = () => {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = 'Fre';

        const manifest = document.createElement('link');
        manifest.rel = 'manifest';
        manifest.href = `${process.env.PUBLIC_URL || ''}/manifest.json`;

        const appleCapable = document.createElement('meta');
        appleCapable.name = 'apple-mobile-web-app-capable';
        appleCapable.content = 'yes';

        document.head.appendChild(manifest);
        document.head.appendChild(appleCapable);

        return () => {
            manifest.remove();
            appleCapable.remove();
            document.title = previousTitle;
        };
    }, []);

    return null;
};

export default PwaManifest;
